import Vue from 'vue';

Vue.component('sales-category-index', () =>
    import(/* webpackChunkName: 'sales-category-index' */ './sales-category-index.vue'),
);
